var Utils = require("./utils");
var queryArray = Utils.queryArray;
/* eslint-disable */

function openModal(videoId, provider) {
  var iframe = document.createElement("iframe");
  iframe.id = "video-player";
  iframe.frameBorder = 0;
  iframe.allow = "autoplay; fullscreen";
  iframe.allowfullscreen = true;
  iframe.width = 800;
  iframe.height = 450;

  if (provider == "Vimeo") {
    iframe.src = "https://player.vimeo.com/video/" + videoId;
    iframe.title = "vimeo-player";
    iframe.setAttribute("data-clip-info", videoId);
  } else {
    iframe.src =
      "https://youtube.com/embed/" +
      videoId +
      "?autoplay=0&title=0&byline=0&portrait=0";
  }

  document.querySelector(".video-responsive").appendChild(iframe);
  document.querySelector("#modal").classList.add("open");
}

function buttonClicked(e) {
  if (e) e.preventDefault();
  var button = this;
  this.classList.add("active");
  var videoId = button.getAttribute("data-video-id");
  var provider = button.getAttribute("data-provider");
  openModal(videoId, provider);
}

function closeModal(e) {
  if (e) e.preventDefault();
  document.querySelector("#modal").classList.remove("open");
  document.querySelector(".modal-body iframe").remove();
  var videos = queryArray(".video");
  videos.forEach(function(video) {
    video.classList.remove("active");
  });
}

function checkVideoHash(e) {
  if (e) e.preventDefault();
  var hash = window.location.hash;
  if (hash.match(/#video-\d$/)) {
    var videoId = document.querySelector(hash).getAttribute("data-video-id");
    var provider = document.querySelector(hash).getAttribute("data-provider");
    openModal(videoId, provider);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var videos = queryArray(".video");
  var modalCloseButton = document.querySelector(".btn-close-video");
  checkVideoHash();
  $(window).on("hashchange", checkVideoHash);

  videos.forEach(function(video) {
    video.addEventListener("click", buttonClicked);
  });
  modalCloseButton.addEventListener("click", closeModal);
  // Close when clicked anywhere outside of the iframe
  document.querySelector("#modal").addEventListener("click", closeModal);
});
